module.exports = __webpack_public_path__ + "static/media/show-gal-6.d8391254.jpg";